import React, { memo, useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { FilterOutlined } from '@ant-design/icons';
import { Spin, Row, Col, Button } from 'antd';

import { Formik, Form, Field } from 'formik';
import type { FormikProps } from 'formik';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import type { IFilter } from 'v2/interfaces/whitelist';
import whitelistService, { InitialFilter } from 'v2/services/whitelist';

import FilterSchema from './validations';

const Filter = () => {
  const [isLoading] = useObservable(() => whitelistService.isLoading(), []);

  const CustomerTypeOptions = [
    {
      label: 'Nome',
      value: 'customer_name'
    },
    {
      label: 'E-mail',
      value: 'customer_email'
    },
    {
      label: 'CPF/CNPJ',
      value: 'customer_document'
    }
  ];

  const onSubmit = useCallback((values: IFilter, { setSubmitting, resetForm }: FormikProps<IFilter>) => {
    const newFilter: any = {};
    newFilter[values.type] = values[values.type];
    whitelistService.setFilter(newFilter);
    resetForm({ values });
    setSubmitting(false);
  }, []);

  return (
    <div className='mb-4 rounded-lg bg-white p-4'>
      <Formik initialValues={InitialFilter} validationSchema={FilterSchema} onSubmit={onSubmit}>
        {({ values, isValid, isSubmitting, resetForm, setFieldValue }) => {
          const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
            const v = e.target.value;
            setFieldValue('customer_name', '');
            setFieldValue('customer_email', '');
            setFieldValue('customer_document', '');
            setFieldValue('type', v);
          };

          return (
            <Form id='whitelist-form'>
              <Row gutter={[8, 8]}>
                <Col xs={24} md={4}>
                  <Field
                    id='type'
                    name='type'
                    label='Cliente'
                    fullWidth
                    options={CustomerTypeOptions}
                    component={SelectFormField}
                    onChange={onChangeCustomerType}
                  />
                </Col>
                <Col xs={24} md={8}>
                  <Field
                    id={values.type}
                    name={values.type}
                    component={TextFormField}
                    fullWidth
                    label={
                      values.type === 'customer_document'
                        ? 'CPF/CNPJ'
                        : values.type === 'customer_email'
                          ? 'E-mail'
                          : 'Nome'
                    }
                    placeholder={
                      values.type === 'customer_name'
                        ? 'Insira o nome'
                        : values.type === 'customer_email'
                          ? 'Insira o e-mail'
                          : 'Insira o CPF/CNPJ'
                    }
                    mask={values.type === 'customer_document' ? 'document' : null}
                  />
                </Col>
                <Col md={6}></Col>
                <Col xs={24} md={2} className='md:pt-5'>
                  <Button
                    className='mt-6 w-full'
                    disabled={isSubmitting || isLoading}
                    onClick={() =>
                      resetForm({
                        values: { type: values.type, customer_name: '', customer_document: '', customer_email: '' }
                      })
                    }
                  >
                    Limpar
                    {(isLoading || isSubmitting) && <Spin size='small' className='ml-2' />}
                  </Button>
                </Col>
                <Col xs={24} md={4} className='md:pt-5'>
                  <Button
                    className='mt-6 w-full'
                    type='primary'
                    disabled={!isValid || isSubmitting || isLoading}
                    htmlType='submit'
                    icon={<FilterOutlined />}
                  >
                    Filtrar
                    {(isLoading || isSubmitting) && <Spin size='small' className='ml-2' />}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default memo(Filter);
